module.exports = __webpack_public_path__ + "img/img_redirect.e03dee21.png";